


































import { Component, Prop, Vue } from "vue-property-decorator";
import { getFinishImage } from "@/utility/helpers";
import {
  Finish,
  FinishDisplayName,
  FinishHandle
} from "@/models/products/finish";

@Component({
  directives: {
    "click-outside": {
      bind(el: any, binding: any) {
        el._clickOutside = (e: Event) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el: any) {
        document.removeEventListener("click", el._clickOutside);
      }
    }
  }
})
export default class DropdownFinishes extends Vue {
  @Prop() finishes!: Finish[];
  @Prop() selected!: FinishHandle;
  protected FinishDisplayName = FinishDisplayName;
  protected getFinishImage = getFinishImage;
  protected isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  close() {
    this.isOpen = false;
  }

  public updateFinish(fieldValue: string) {
    this.$emit("updateItem", fieldValue);
    this.close();
  }

  get displayName(): string {
    if (this.selected) {
      const name = (this.selected as any).toUpperCase();
      return FinishDisplayName[name];
    } else {
      return "";
    }
  }
}
